import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ROUTES } from "./constants/routes";
import Home from "./pages/home";
import Templates from "./pages/templates";
import Design from "./pages/design";
import Projects from "./pages/projects";
import Users from "./pages/users";
import Login from "./pages/auth/login";
import LoaderPage from "./pages/loader-page";
import MainLayout from "./components/common/main-layout/main-layout"; // Import MainLayout
import { useAuth } from "./contexts/auth.context";
import Categories from "./pages/categories";
import CategoryFormPage from "./pages/category-form-page";
import Subcategories from "./pages/subcategories";
import SubcategoryFormPage from "./pages/subcategory-form-page";
import TemplateSettingsFormPage from "./pages/template-settings-form-page";
import PrintLocations from "./pages/print-locations";
import SetFormPage from "./pages/set-form-page";
import Sets from "./pages/sets";

const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: <MainLayout />, // Use MainLayout here
    children: [
      {
        path: ROUTES.HOME,
        element: <Home />,
      },
      {
        path: ROUTES.SET_FORM, // create set page
        element: <SetFormPage />,
      },
      {
        path: ROUTES.SET_FORM_WITH_ID, // update set page
        element: <SetFormPage />,
      },
      {
        path: ROUTES.SETS,
        element: <Sets />,
      },
      {
        path: ROUTES.TEMPLATE_SETTINGS_FORM_WITH_ID, // update template settings only page
        element: <TemplateSettingsFormPage />,
      },
      {
        path: ROUTES.TEMPLATES,
        element: <Templates />,
      },
      {
        path: ROUTES.PRINT_LOCATIONS,
        element: <PrintLocations />,
      },
      {
        path: ROUTES.CATEGORIES,
        element: <Categories />,
      },
      {
        path: ROUTES.CATEGORY_FORM_WITH_ID, // update category
        element: <CategoryFormPage />,
      },
      {
        path: ROUTES.CATEGORY_FORM, // create category
        element: <CategoryFormPage />,
      },
      {
        path: ROUTES.SUBCATEGORIES,
        element: <Subcategories />,
      },
      {
        path: ROUTES.SUBCATEGORY_FORM_WITH_ID, // update subcategory
        element: <SubcategoryFormPage />,
      },
      {
        path: ROUTES.SUBCATEGORY_FORM, // create subcategory
        element: <SubcategoryFormPage />,
      },
      {
        path: ROUTES.PROJECTS,
        element: <Projects />,
      },
      {
        path: ROUTES.USERS,
        element: <Users />,
      },
    ],
  },
  {
    path: ROUTES.DESIGN_WITH_ID,
    element: <Design />,
  },
  {
    path: ROUTES.DESIGN,
    element: <Design />,
  },
]);

const Main = () => {
  const { isLoggedIn, isCheckingAuth } = useAuth();

  return (
    <>
      {isCheckingAuth && <LoaderPage />}
      {!isCheckingAuth && !isLoggedIn && <Login />}
      {!isCheckingAuth && isLoggedIn && <RouterProvider router={router} />}
    </>
  );
};

export default Main;
